export default "__VITE_ASSET__df925109__"